import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_info_circle_gray.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ed8ed696")

_pushScopeId("data-v-ed8ed696")
const _hoisted_1 = {
  key: 0,
  "data-testid": "pickup-schedule-config-popover-pickup-time",
  class: "pickup-time-popover absolute right-0 top-full z-30 mt-2 rounded-lg border border-gray-lp-400 bg-white shadow-lg"
}
const _hoisted_2 = { class: "px-4 pb-2 pt-4" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_4 = { class: "pickup-time-options mx-4 overflow-y-auto rounded-lg border border-gray-lp-400 py-1" }
const _hoisted_5 = { class: "whitespace-nowrap text-xs text-gray-lp-300" }
const _hoisted_6 = {
  key: 0,
  class: "px-4 py-6 text-center text-xs text-gray-lp-500"
}
const _hoisted_7 = { class: "px-4 pb-4 pt-2.5" }
const _hoisted_8 = { class: "flex items-center gap-1.5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-3.5 w-3.5",
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "text-xs text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "popover-fade" }, {
    default: _withId(() => [
      (_ctx.open)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.popoverTitle")), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slotStarts, (start) => {
                return (_openBlock(), _createBlock("button", {
                  key: start,
                  type: "button",
                  "data-testid": 
            `pickup-schedule-config-popover-time-option-${_ctx.testIdTime(start)}`
          ,
                  class: ["time-option flex w-full cursor-pointer items-center gap-2 px-2 py-1.5 text-left hover:bg-gray-lp-1000", _ctx.isExistingStart(start) ? 'bg-gray-lp-1000' : ''],
                  onClick: ($event: any) => (_ctx.selectStart(start))
                }, [
                  _createVNode("span", {
                    class: ["time-option-indicator flex-shrink-0 rounded-full", 
              _ctx.isExistingStart(start) ? 'time-option-indicator-active' : ''
            ]
                  }, null, 2),
                  _createVNode("span", _hoisted_5, _toDisplayString(start) + " - " + _toDisplayString(_ctx.addOneHour(start)), 1)
                ], 10, ["data-testid", "onClick"]))
              }), 128)),
              (!_ctx.slotStarts.length)
                ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.emptyTimeOptions")), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_7, [
              (_ctx.duplicateError)
                ? (_openBlock(), _createBlock("p", {
                    key: 0,
                    "data-testid": `pickup-schedule-config-error-duplicate-time-${_ctx.day}`,
                    class: "duplicate-error mb-2 text-xs"
                  }, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.duplicateTime")), 9, ["data-testid"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.durationFooter")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})